
import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import TeamManagement from "./TeamManagement"

const TeamManagementLayout = () => {
  return (
    <div className="App">
      <Navbar />
      <TeamManagement />
      <Footer />
    </div>
  );
};

export default TeamManagementLayout;
